import {Box, CardActions, CardContent, Stack, css, styled} from '@mui/material';
import {StyledBoxProps} from './types';

const StyledCardActions = styled(CardActions)`
	padding: 0 8px 16px;
	justify-content: flex-end;
`;

const StyledCardContent = styled(CardContent)`
	display: flex;
	gap: 8px;
	align-items: center;
	justify-content: space-between;
`;

const StyledLoadingStack = styled(Stack)`
	align-items: center;
	justify-content: center;
	color: ${({theme}) => theme.palette.other.progressBar};
	gap: 16px;
`;

const StyledBox = styled(Box)<StyledBoxProps>`
	margin-inline: -32px;

	& .slide {
		flex: 0 0 95%;
	}

	& .slide:first-of-type {
		padding-left: 32px;
		flex: 0 0 98%;
	}

	& .slide:last-of-type {
		padding-right: 32px;
		flex: 0 0 98%;
	}

	${({theme}) => theme.breakpoints.up('lg')} {
		margin-left: 0px;

		& .slide {
			flex-basis: 90%;
		}

		& .slide:first-of-type {
			padding-left: 0px;
			flex-basis: 95%;
		}

		& .slide:last-of-type {
			flex-basis: 95%;
		}
	}

	${({theme}) => theme.breakpoints.up('xl')} {
		& .slide {
			flex-basis: 92%;
		}

		& .slide:first-of-type {
			padding-left: 0px;
			flex-basis: 96%;
		}

		& .slide:last-of-type {
			flex-basis: 96%;
		}
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		margin-inline: -16px;

		& .slide {
			flex-basis: 90%;
		}

		& .slide:first-of-type {
			flex-basis: 95%;
			padding-left: 16px;
		}

		& .slide:last-of-type {
			flex-basis: 95%;
			padding-right: 16px;
		}
	}

	${({$isSingleItem}) =>
		$isSingleItem &&
		css`
			& .slide {
				flex-basis: 100%;
			}

			& .slide:first-of-type {
				flex-basis: 100%;
			}

			& .slide:last-of-type {
				flex-basis: 100%;
			}
		`}

	${({$isNotredameSaude}) =>
		$isNotredameSaude &&
		css`
			& .slide > * {
				border: 1px solid #e9eaeb;
			}
		`}
`;

export {StyledCardActions, StyledCardContent, StyledLoadingStack, StyledBox};
